import React from "react";
import { Wardrobe as WardrobeApp } from "../apps/wardrobe";
import { Layout } from "../components";

const Wardrobe: React.FC = () => {
  return (
    <Layout title="My Wardrobe">
      <WardrobeApp />
    </Layout>
  );
};

export default Wardrobe;
